import { ArticleContentSection, ComponentName } from 'api'
import { TextAndText } from 'sections/articles/content-components/text-and-text'
import { TextAndImage } from 'sections/articles/content-components/text-and-image'
import { TeamMembers } from 'sections/articles/content-components/team-members/team-members'
import { SectionWrapper } from 'sections/articles/content-components/section-wrapper'

import { FullWidthImage } from '../full-width-image'
import { TextOnly } from '../text-only'

//NOTE: We can get layout by object key/layout-name but with this approach, we lose the type checking
export const ComponentLayout = (componentInfo: ArticleContentSection) => {
  const componentName = componentInfo.__component

  switch (componentName) {
    case ComponentName.fullWidthImage:
      return (
        <SectionWrapper>
          <FullWidthImage data={componentInfo} />
        </SectionWrapper>
      )
    case ComponentName.textAndImage:
      return (
        <SectionWrapper>
          <TextAndImage data={componentInfo} />
        </SectionWrapper>
      )
    case ComponentName.text:
      return (
        <SectionWrapper>
          <TextOnly data={componentInfo} />
        </SectionWrapper>
      )
    case ComponentName.textAndText:
      return (
        <SectionWrapper>
          <TextAndText data={componentInfo} />
        </SectionWrapper>
      )
    case ComponentName.teamMembers:
      return <TeamMembers data={componentInfo} />
  }

  return null
}
